import { useEffect, useMemo, useState } from "react";
import { ArticleProperties } from "../../../types/blog.type";
import Table, { ColumnsType } from "antd/lib/table";
import { Space, Typography } from "antd";
import { Link } from "react-router-dom";
import NotSet from "../../../components/NotSet";
import { urlBlog } from "../../blog/posts/helpers/urlBlog";
import { getFullName } from "../../../helpers/name";
import { formatDate } from "../../../helpers/format";
import { thousandSeparator } from "../../../helpers/numberFormat";

type IProps = {
	contentType: string;
	tableType: string;
	dataProps: any[];
};

const { Text } = Typography;

const StatisticTopArticlesTable: React.FC<IProps> = ({ contentType, tableType, dataProps }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [data, setData] = useState<any[]>([]);

	async function fetchMostViewedData() {
		setIsLoading(true);
		if (dataProps && dataProps?.length > 0) {
			setData(dataProps || []);
		}
		setIsLoading(false);
	}

	async function fetchMostSharedData() {
		setIsLoading(true);
		if (dataProps && dataProps?.length > 0) {
			setData(dataProps || []);
		}
		setIsLoading(false);
	}

	useEffect(() => {
		if (tableType === "views") {
			fetchMostViewedData();
		}
		if (tableType === "shares") {
			fetchMostSharedData();
		}
	}, [dataProps]);

	const dataSort = useMemo(() => {
		if (tableType === "views")
			return data.filter((v) => +v.viewCount > 0).sort((a, b) => +b.viewCount - +a.viewCount);
		if (tableType === "shares")
			return data.filter((v) => +v.shareCount > 0).sort((a, b) => +b.shareCount - +a.shareCount);
	}, [data, tableType]);

	const columns: ColumnsType<any> = [
		{
			title: "TITLE",
			key: "title",
			dataIndex: "title",
			render: (title: string, record: ArticleProperties) => {
				let url = `${urlBlog}/article/${record?.slug}`;

				return (
					<Space direction="vertical">
						<Link to={"/blog-posts/" + record.articleId}>{title ? title?.toUpperCase() : <NotSet />}</Link>
					</Space>
				);
			},
		},
		{
			title: "Blog Admin",
			key: "metaCreatedByUser",
			dataIndex: "metaCreatedByUser",
			render(value) {
				return <>{getFullName(value)}</>;
			},
		},
		{
			title: "AUTHOR",
			key: "authorName",
			dataIndex: "authorName",
			render(value) {
				return <>{value ? value : <NotSet />}</>;
			},
		},
		{
			title: tableType === "views" ? "TOTAL VIEWS" : tableType === "shares" ? "TOTAL SHARES" : "",
			key: "title",
			render: (title: string, record) => (
				<Text>
					{tableType === "views" && thousandSeparator(record.viewCount)}
					{tableType === "shares" && thousandSeparator(record.shareCount)}
				</Text>
			),
		},
		{
			title: "PUBLISH AT",
			key: "publicationAt",
			dataIndex: "publicationAt",
			render: (publicationAt: Date, record: ArticleProperties) => {
				return publicationAt ? formatDate(publicationAt) : formatDate(record.createdAt);
			},
		},
	];

	return (
		<>
			{/* {JSON.stringify(data)} */}
			<Table
				loading={isLoading}
				columns={columns}
				dataSource={dataSort}
				rowKey="articleId"
				pagination={false}
			/>
		</>
	);
};

export default StatisticTopArticlesTable;
